module.exports = __webpack_public_path__ + "static/icons/icon-chevron-left--white-d17a90f0749a2877eea8bb6b3e36cabd.svg";